/*
  Which employee this tab is navigating the site as, if anyone.

  Held in sessionStorage so it belongs to one tab, survives a reload, and ends
  when the tab is closed. Every API call sends it as a header (see
  useAuthenticatedFetch); the server decides whether to honour it.

  Starting and stopping both reload the page rather than patching state in
  place: everything already fetched or held in a component belongs to the
  other person, and a reload is the one way to be sure none of it survives.
*/

const STORAGE_KEY = 'ec.impersonateEmployeeId';

export const IMPERSONATE_HEADER = 'X-Impersonate-Employee-Id';

export const getImpersonatedEmployeeId = () => {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) || null;
  } catch {
    return null;
  }
};

const setStored = (employeeId) => {
  try {
    if (employeeId) window.sessionStorage.setItem(STORAGE_KEY, String(employeeId));
    else window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage blocked: impersonation simply does not stick, which is safe.
  }
};

export const startImpersonating = (employeeId, landingPath = '/') => {
  setStored(employeeId);
  window.location.assign(landingPath);
};

export const stopImpersonating = (landingPath = '/admin/employees') => {
  setStored(null);
  window.location.assign(landingPath);
};

// Dropped without navigating, for when the server has refused it and the page
// only needs to come back as the real person.
export const clearImpersonationAndReload = () => {
  setStored(null);
  window.location.reload();
};
